import axios from "axios";
import server_config from '../ServerConfiguration';

const fevir_node_server_address = server_config["fevir_node_server_address"];

const addFoisFromFlis = async (apiToken = null, targetResources = null) => {
    if (!targetResources) {
        console.log("no targetResources");
        return null;
    }
    let fliList = [];
    for (let resource of targetResources) {
        if (!resource?.id && resource?.fli) {
            fliList.push(resource.fli);
        }
    }
    console.log("CALLING SERVER with getfoilistfromflilist")
    return await axios({
        method: 'POST',
        url: fevir_node_server_address,
        timeout: 120000,
        data: {
            'functionid': 'getfoilistfromflilist',
            'apiToken': apiToken,
            'fliList': fliList
        },
    }).then((resp) => {
        if (resp?.data) {
            return resp.data;
            //resp.data includes { success: true, foilist: [], flitofoi: {} }
        }
        console.log("NO RESPONSE from getfoilistfromflilist call");
    }).catch((error) => { console.log(error); });
};

export default addFoisFromFlis;